import '../styles/skeleton.scss';

export const skeletonDirective = (el, binding) => {
  const status = binding.value;
  if (status === true) {
    el.classList.add('skeleton');
  }
  if (status === 'loaded' || status === false) {
    el.classList.remove('skeleton');
  }
};
